import role from "./role/en";
import release from "./release/en";

export default {
  role,
  release,
  settings: "Settings",
  roles: "Roles",
};
